import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { required, phoneNumber } from '@mhub/web-validations';
import {
  Button,
  Form,
  Grid,
  Header,
  Modal,
} from 'semantic-ui-react';

import AppForm from '../../components/AppForm';
import PhoneInput from '../../components/AppForm/PhoneInput';
import SearchHimsPostcodes from '../../components/SearchHimsPostcodes';
import SearchHimsDistricts from '../../components/SearchHimsDistricts';

import INTL_CALL_CODES from '../../constants/intlCallCodes';
import { SPA_LAWYER_REP_OPTIONS } from '../../constants/lawyerCaseStatuses';
import STATES from '../../constants/states';

import { getPhoneValidRegex } from '../../utils/validations/phone';

class AssignSecondaryLawyer extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onCreate: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
  }
  static mapStateToProps = state => ({
    phoneValidationPresets: state.phoneValidationPresets,
  })
  static getPropsToState = (props) => {
    const phoneValidationPresets = props.phoneValidationPresets.data;
    let data = {
      repType: props.repType,
      name: '',
      lawFirmName: '',
      mobilePrefix: '60',
      mobile: '',
      address1: '',
      postcode: '',
      city: '',
      state: '',
    };
    if (props.data) {
      data = props.data;
    }
    return {
      data,
      phoneValidationPresets,
    };
  }
  constructor(props) {
    super(props);
    const state = AssignSecondaryLawyer.getPropsToState(props);
    this.state = {
      ...state,
      errMessages: [],
    };
    this.validation = {
      repType: createRef(),
      name: createRef(),
      lawFirmName: createRef(),
      mobilePrefix: createRef(),
      mobile: createRef(),
      address1: createRef(),
      himsKodPoskod: createRef(),
      himsKodDaerah: createRef(),
      city: createRef(),
      state: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = AssignSecondaryLawyer.getPropsToState(nextProps);
    this.setState({
      ...state,
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { data } = this.state;
    return AppForm.validate(this.validation, data)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        if (data.id) {
          this.props.onUpdate(event, validations, data);
        } else {
          this.props.onCreate(event, validations, data);
        }
      });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnConfirm = (e) => {
    e.preventDefault();
    this.form.handleSubmit(event);
  }
  handleChange = (e, d) => {
    const { data } = this.state;
    data[d.name] = d.value;
    this.setState({ data });
  }
  handleSelectChange = (e, d) => {
    const { data } = this.state;
    data[d.name] = d.value;
    if (d.name === 'state') {
      data.postcode = '';
      data.himsKodPoskod = '';
      data.city = '';
      data.himsKodBandar = '';
      data.himsKodDaerah = '';
    }
    this.setState({ data });
  }
  handleSelectHimsPostcode = (himsPostcode) => {
    const { data } = this.state;

    data.himsKodPoskod = himsPostcode ? himsPostcode.value : '';
    data.himsKodBandar = himsPostcode ? himsPostcode.kod_bandar_id : '';
    data.himsKodNegeri = himsPostcode ? himsPostcode.kod_negeri_id : '';

    data.postcode = himsPostcode ? himsPostcode.text : '';
    data.city = himsPostcode ? himsPostcode.bandar : '';
    const himsState = himsPostcode ? himsPostcode.kod_negeri_id : '';
    const srState = STATES.find(s => s.kod_negeri_id === himsState);
    data.state = srState ? srState.value : '';

    this.setState({ data });
  }
  handleSelectHimsDistrict = (himsDistrict) => {
    const { data } = this.state;
    data.himsKodDaerah = himsDistrict ? himsDistrict.value : '';

    this.setState({ data });
  }
  renderActionButtons = () => (
    <Grid>
      <Grid.Row>
        <Grid.Column mobile={16} computer={16}>
          <Grid.Row>
            <Button negative onClick={this.handleOnClose} icon="cancel" content="Cancel" />
            <Button
              positive
              onClick={this.handleOnConfirm}
              icon="checkmark"
              content="Confirm"
              data-bot-target="confirm"
            />
          </Grid.Row>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  render() {
    const { data, phoneValidationPresets } = this.state;
    return (
      <Modal
        className="booking-status-note"
        open={this.props.open === true}
        onClose={this.handleOnClose}
        size="large"
      >
        <Header icon="add user" content="Assign 2nd SPA Lawyer" />
        <Modal.Content>
          <Modal.Description style={{ paddingBottom: '1em' }}>
            <div>
              <p>Please aware that this additional lawyer is only for HIMS e-SPA usage and records. It won&apos;t appear in MHub Lawyer module.</p>
              <AppForm
                onSubmit={this.handleSubmit}
                error={this.state.errMessages.length > 0}
                ref={(ref) => { this.form = ref; }}
              >
                <Grid stackable>
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <AppForm.Select
                      label="Lawyer represents (in e-SPA)"
                      name="repType"
                      ref={this.validation.repType}
                      validation={[required]}
                      validateLabel="Lawyer represents (in e-SPA)"
                      options={SPA_LAWYER_REP_OPTIONS}
                      value={data.repType}
                      onChange={this.handleSelectChange}
                      disabled={!data.id}
                    />
                    <AppForm.Input
                      autoComplete="off"
                      name="name"
                      onChange={this.handleChange}
                      placeholder="Lawyer Name*"
                      label="Lawyer Name*"
                      ref={this.validation.name}
                      validation={[required]}
                      validateLabel="Lawyer Name"
                      value={data.name}
                    />
                    <AppForm.Input
                      autoComplete="off"
                      name="lawFirmName"
                      onChange={this.handleChange}
                      placeholder="Lawyer Firm Name*"
                      label="Lawyer Firm Name*"
                      ref={this.validation.lawFirmName}
                      value={data.lawFirmName}
                      validation={[required]}
                      validateLabel="Lawyer Firm Name"
                    />
                    <Form.Group widths="equal">
                      <AppForm.Select
                        name="mobilePrefix"
                        onChange={this.handleChange}
                        options={INTL_CALL_CODES}
                        label="Lawyer Mobile Prefix*"
                        placeholder="Lawyer Mobile Prefix*"
                        search
                        selectOnBlur={false}
                        validation={[required]}
                        ref={this.validation.mobilePrefix}
                        validateLabel="Lawyer Mobile Prefix"
                        value={data.mobilePrefix}
                      />
                      <PhoneInput
                        autoComplete="off"
                        name="mobile"
                        onChange={this.handleChange}
                        label="Lawyer Mobile Number*"
                        placeholder="Lawyer Mobile Number*"
                        prefix={data.mobilePrefix}
                        ref={this.validation.mobile}
                        type="tel"
                        validation={[required, {
                          validate: phoneNumber,
                          option: data.mobilePrefix === 'other' ? {} : {
                            isMobile: true,
                            phonePrefix: data.mobilePrefix,
                            validRegex: getPhoneValidRegex(
                              phoneValidationPresets,
                              data.mobilePrefix,
                              'mobile',
                            ),
                          },
                        }]}
                        value={data.mobile}
                        validateLabel="Lawyer Mobile Number"
                      />
                    </Form.Group>
                    <SearchHimsDistricts
                      validateRef={this.validation.himsKodDaerah}
                      name="himsKodDaerah"
                      validation={[required]}
                      onSelect={this.handleSelectHimsDistrict}
                      state={data.state}
                      value={data.himsKodDaerah}
                    />
                  </Grid.Column>

                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <AppForm.Input
                      name="address1"
                      label="Address 1*"
                      placeholder="Address 1*"
                      onChange={this.handleChange}
                      ref={this.validation.address1}
                      validation={[required]}
                      validateLabel="Address 1"
                      value={data.address1}
                    />
                    <AppForm.Input
                      name="address2"
                      label="Address 2"
                      placeholder="Address 2"
                      value={data.address2}
                      onChange={this.handleChange}
                    />
                    <AppForm.Input
                      name="address3"
                      label="Address 3"
                      placeholder="Address 3"
                      value={data.address3}
                      onChange={this.handleChange}
                    />
                    <Form.Group widths="equal">
                      <SearchHimsPostcodes
                        validateRef={this.validation.himsKodPoskod}
                        name="himsKodPoskod"
                        validation={[required]}
                        onSelect={this.handleSelectHimsPostcode}
                        state={data.state}
                        value={data.himsKodPoskod}
                      />
                      <AppForm.Input
                        name="city"
                        label="City*"
                        placeholder="City*"
                        ref={this.validation.city}
                        validation={[required]}
                        validateLabel="City"
                        value={data.city}
                        readOnly
                      />
                    </Form.Group>
                    <AppForm.Select
                      name="state"
                      label="State*"
                      placeholder="State*"
                      ref={this.validation.state}
                      validation={[required]}
                      validateLabel="State"
                      options={STATES}
                      value={data.state}
                      onChange={this.handleSelectChange}
                    />
                  </Grid.Column>
                </Grid>
              </AppForm>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {this.renderActionButtons()}
        </Modal.Actions>
      </Modal>
    );
  }
}

export default connect(AssignSecondaryLawyer.mapStateToProps)(AssignSecondaryLawyer);




// WEBPACK FOOTER //
// ./src/containers/modals/AssignSecondaryLawyer.jsx